import { Box, Center, Stack, Text } from "@chakra-ui/react";
import { message } from "components/base";
import { memo, useRef } from "react";
import { isFileTypeImage } from "utils/file";

interface Props {
  isDisabled?: boolean;
  cameraIcon: React.ReactNode;
  imageIcon: React.ReactNode;

  onOpenCamera: () => void;
  onSelectFile: (file: File) => void;
}

const ImageForm = (props: Props) => {
  const { cameraIcon, imageIcon, isDisabled, onOpenCamera, onSelectFile } =
    props;
  const inputFileRef = useRef<any>();

  const onClearFile = (e: React.MouseEvent<HTMLInputElement>) => {
    if (isDisabled) return;
    const target = e.target as HTMLInputElement;
    target.value = "";
  };

  const onBeforeSelectFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!isFileTypeImage(file?.type)) {
      message.warning(["画像を選択してください"]);

      return;
    }

    onSelectFile(file);
    inputFileRef.current.value = "";
  };

  return (
    <Stack
      flexDirection="row"
      width="100%"
      border="1px solid #c1c0c0"
      className="capture-group draggable-area"
      backgroundColor={"#fff"}
      borderRadius={"0.5rem"}
      divider={
        <Center width="2px">
          <Box
            width="1px"
            height="100%"
            maxHeight="80%"
            style={{
              backgroundImage: `linear-gradient(to bottom, #c1c0c0 50%, transparent 50%)`,
              backgroundSize: "5px 10px",
              backgroundRepeat: "repeat",
            }}
          />
        </Center>
      }
    >
      <Center
        gap="0.25rem"
        flexDirection="column"
        flexGrow={1}
        flexBasis="50%"
        as="button"
        cursor={"pointer"}
        width={"50%"}
        py="2rem"
        color="#525252"
        onClick={() => {
          if (isDisabled) return;
          onOpenCamera();
        }}
      >
        {}
        {cameraIcon}
        <Text textAlign="center" fontSize={"1rem"}>
          撮る
        </Text>
      </Center>
      <Center
        gap="0.25rem"
        width={"50%"}
        flexDirection="column"
        flexGrow={1}
        flex="1"
        flexBasis="50%"
        py="2rem"
        as="label"
        cursor={"pointer"}
        color="#525252"
      >
        <input
          type="file"
          style={{ display: "none" }}
          disabled={isDisabled}
          ref={inputFileRef}
          accept="image/*"
          onClick={onClearFile}
          onChange={onBeforeSelectFile}
        />
        {imageIcon}
        <Text textAlign="center" fontSize={"1rem"}>
          選択
        </Text>
      </Center>
    </Stack>
  );
};

export default memo(ImageForm);
